/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AutotraderAdvertStatusEnum } from '../models/AutotraderAdvertStatusEnum';
import type { AvailableStockInfo } from '../models/AvailableStockInfo';
import type { CarBodyTypeFilter } from '../models/CarBodyTypeFilter';
import type { EngineSizeFilter } from '../models/EngineSizeFilter';
import type { ExternalStockFilteredResponseDTO } from '../models/ExternalStockFilteredResponseDTO';
import type { ExternalStockFilteredResponseDTOPagedListData } from '../models/ExternalStockFilteredResponseDTOPagedListData';
import type { FilledTemplateDto } from '../models/FilledTemplateDto';
import type { FinanceTypeEnum } from '../models/FinanceTypeEnum';
import type { FuelTypeFilter } from '../models/FuelTypeFilter';
import type { ParamsForCreateTemplateDto } from '../models/ParamsForCreateTemplateDto';
import type { StockAttGrabDto } from '../models/StockAttGrabDto';
import type { StockAttGrabRequest } from '../models/StockAttGrabRequest';
import type { StockCarDTO } from '../models/StockCarDTO';
import type { StockCarImage } from '../models/StockCarImage';
import type { StockCarPageDTO } from '../models/StockCarPageDTO';
import type { StockCarsFilterWithDataDTO } from '../models/StockCarsFilterWithDataDTO';
import type { StockCarsTabFilter } from '../models/StockCarsTabFilter';
import type { StockEtaDto } from '../models/StockEtaDto';
import type { StockFilteredResponseDTOPagedListData } from '../models/StockFilteredResponseDTOPagedListData';
import type { StockFilterResponseDTO } from '../models/StockFilterResponseDTO';
import type { TransmTypeFilter } from '../models/TransmTypeFilter';
import type { VehicleDescriptionTemplateDto } from '../models/VehicleDescriptionTemplateDto';
import type { VehicleDescriptionTemplateInput } from '../models/VehicleDescriptionTemplateInput';
import type { VehicleDescriptionTemplatePropertyDto } from '../models/VehicleDescriptionTemplatePropertyDto';
import type { VehicleTypes } from '../models/VehicleTypes';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StockService {

  /**
   * Get stock vehcles
   * @param requestBody 
   * @returns StockEtaDto Success
   * @throws ApiError
   */
  public static postStockGetVehiclesEta(
requestBody?: Array<number>,
): CancelablePromise<StockEtaDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Stock/GetVehiclesEta',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Get stock vehcles
   * @param carsPerPage Кол-во машин на одной странице
   * @param pageNumber Номер страницы
   * @param tab Вкладка для отображения
 *
 * 0 = Used
 *
 * 1 = DeliveryMileage
 *
 * 2 = ExDemo
 *
 * 3 = New
 *
 * 4 = External
   * @param age Фильтр по возрасту машины. Значение соответствует выбранному N из выпадающего списка "up to N years old"
   * @param bodyType Выбранное значение из списка типов кузова. Значения не соответствуют 1 к 1 с
 * самими типами кузовов
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param vehicleType Тип транспортного средства. Передать null если нужно показать все.
 *
 * 0 = Undefined
 *
 * 1 = Bike (Motorcycle)
 *
 * 2 = Car
 *
 * 3 = Comp (Component vehicle)
 *
 * 4 = Hgv (Heavy Goods Vehicle)
 *
 * 5 = Van (Light Commercial Vehicle)
   * @param engineVolume Фильтр по литражу движка
 *
 * 0 = All
 *
 * 1 = Max13 (1L-1.3L)
 *
 * 2 = Min14Max16 (1.4L-1.6L)
 *
 * 3 = Min17Max19 (1.7L-1.9L)
 *
 * 4 = Min2Max25 (2L-2.5L)
 *
 * 5 = MoreThan25 (more than 2.5L)
   * @param fuelType Фильтр по типу топлива
   * @param manufacturer Производитель, регистронезависимо.
 * Ставить null или пустую строку если поиск по производителю делать не нужно
   * @param model Название модели для поиска, регистронезависимо.
 * Ставить null или пустую строку если поиск по производителю делать не нужно
   * @param mileageMax Максимальный пробег (включительно)
   * @param mileageMin Минимальный пробег (включительно)
   * @param monthlyPaymentMax Максимальный ежемесячный платеж (включительно)
   * @param monthlyPaymentMin Минимальный ежемесячный платеж (включительно)
   * @param priceMax Максимальная стоимость авто (включительно)
   * @param priceMin Минимальная стоимость авто (включительно)
   * @param regNo 
   * @param isSpecialOffer 
   * @param sortByPriceAsc Порядок сортировки по цене (прямой или обратный)
   * @param isTransmissionAutomatic Тип коробки передач. null если все виды, true для автоматических коробок.
   * @param isMotability 
   * @returns StockCarPageDTO Success
   * @throws ApiError
   */
  public static getStockVehicles(
carsPerPage?: number,
pageNumber?: number,
tab?: StockCarsTabFilter,
age?: number,
bodyType?: CarBodyTypeFilter,
vehicleType?: VehicleTypes,
engineVolume?: EngineSizeFilter,
fuelType?: Array<FuelTypeFilter>,
manufacturer?: string,
model?: string,
mileageMax?: number,
mileageMin?: number,
monthlyPaymentMax?: number,
monthlyPaymentMin?: number,
priceMax?: number,
priceMin?: number,
regNo?: string,
isSpecialOffer?: boolean,
sortByPriceAsc?: boolean,
isTransmissionAutomatic?: boolean,
isMotability?: boolean,
): CancelablePromise<StockCarPageDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/vehicles',
      query: {
        'CarsPerPage': carsPerPage,
        'PageNumber': pageNumber,
        'Tab': tab,
        'Age': age,
        'BodyType': bodyType,
        'VehicleType': vehicleType,
        'EngineVolume': engineVolume,
        'FuelType': fuelType,
        'Manufacturer': manufacturer,
        'Model': model,
        'MileageMax': mileageMax,
        'MileageMin': mileageMin,
        'MonthlyPaymentMax': monthlyPaymentMax,
        'MonthlyPaymentMin': monthlyPaymentMin,
        'PriceMax': priceMax,
        'PriceMin': priceMin,
        'RegNo': regNo,
        'IsSpecialOffer': isSpecialOffer,
        'SortByPriceAsc': sortByPriceAsc,
        'IsTransmissionAutomatic': isTransmissionAutomatic,
        'IsMotability': isMotability,
      },
    });
  }

  /**
   * @param stockId 
   * @returns StockAttGrabDto Created
   * @throws ApiError
   */
  public static getStockAttentionGrabber(
stockId: number,
): CancelablePromise<StockAttGrabDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/AttentionGrabber/{stockId}',
      path: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param stockId 
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postStockCreateAttentionGrabber(
stockId: number,
requestBody?: StockAttGrabRequest,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Stock/CreateAttentionGrabber/{stockId}',
      path: {
        'stockId': stockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param stockId 
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static putStockUpdateAttentionGrabber(
stockId: number,
requestBody?: StockAttGrabRequest,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Stock/UpdateAttentionGrabber/{stockId}',
      path: {
        'stockId': stockId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postStockUpdateMileage(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Stock/UpdateMileage',
    });
  }

  /**
   * Get data for stock filters
   * @param tab
 *
 * 0 = Used
 *
 * 1 = DeliveryMileage
 *
 * 2 = ExDemo
 *
 * 3 = New
 *
 * 4 = External
   * @param page 
   * @param body
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param vehicle
 *
 * 0 = Undefined
 *
 * 1 = Bike (Motorcycle)
 *
 * 2 = Car
 *
 * 3 = Comp (Component vehicle)
 *
 * 4 = Hgv (Heavy Goods Vehicle)
 *
 * 5 = Van (Light Commercial Vehicle)
   * @param engine
 *
 * 0 = All
 *
 * 1 = Max13 (1L-1.3L)
 *
 * 2 = Min14Max16 (1.4L-1.6L)
 *
 * 3 = Min17Max19 (1.7L-1.9L)
 *
 * 4 = Min2Max25 (2L-2.5L)
 *
 * 5 = MoreThan25 (more than 2.5L)
   * @param fuel
 *
 * 0 = Any
 *
 * 1 = Diesel
 *
 * 2 = Petrol
 *
 * 3 = Electric
 *
 * 4 = Hybrid
   * @param age 
   * @param transm 
   * @param manuf 
   * @param model 
   * @param mileageMin 
   * @param mileageMax 
   * @param monthMin 
   * @param monthMax 
   * @param priceMin 
   * @param priceMax 
   * @param regno 
   * @param sort 
   * @returns StockCarsFilterWithDataDTO Success
   * @throws ApiError
   */
  public static getStockFilters(
tab?: StockCarsTabFilter,
page?: number,
body?: CarBodyTypeFilter,
vehicle?: VehicleTypes,
engine?: EngineSizeFilter,
fuel?: FuelTypeFilter,
age?: number,
transm?: boolean,
manuf?: string,
model?: string,
mileageMin?: number,
mileageMax?: number,
monthMin?: number,
monthMax?: number,
priceMin?: number,
priceMax?: number,
regno?: string,
sort?: boolean,
): CancelablePromise<StockCarsFilterWithDataDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/filters',
      query: {
        'tab': tab,
        'page': page,
        'body': body,
        'vehicle': vehicle,
        'engine': engine,
        'fuel': fuel,
        'age': age,
        'transm': transm,
        'manuf': manuf,
        'model': model,
        'mileageMin': mileageMin,
        'mileageMax': mileageMax,
        'monthMin': monthMin,
        'monthMax': monthMax,
        'priceMin': priceMin,
        'priceMax': priceMax,
        'regno': regno,
        'sort': sort,
      },
    });
  }

  /**
   * @param id 
   * @returns StockCarDTO Success
   * @throws ApiError
   */
  public static getStockGetStockCar(
id: number,
): CancelablePromise<StockCarDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/GetStockCar/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param stockId 
   * @returns string Success
   * @throws ApiError
   */
  public static getStockVehicleInfo(
stockId: number,
): CancelablePromise<Record<string, string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/VehicleInfo/{stockId}',
      path: {
        'stockId': stockId,
      },
    });
  }

  /**
   * @returns VehicleDescriptionTemplatePropertyDto Success
   * @throws ApiError
   */
  public static getStockGetVehicleDescriptionTemplateProperties(): CancelablePromise<Array<VehicleDescriptionTemplatePropertyDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/GetVehicleDescriptionTemplateProperties',
    });
  }

  /**
   * @returns VehicleDescriptionTemplateDto Success
   * @throws ApiError
   */
  public static getStockGetVehicleDescriptionTemplates(): CancelablePromise<Array<VehicleDescriptionTemplateDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/GetVehicleDescriptionTemplates',
    });
  }

  /**
   * @param condition 
   * @param manuf 
   * @param model 
   * @param generation 
   * @param trim 
   * @returns ParamsForCreateTemplateDto Success
   * @throws ApiError
   */
  public static getStockGetParamsForCreateTemplate(
condition?: string,
manuf?: string,
model?: string,
generation?: string,
trim?: string,
): CancelablePromise<ParamsForCreateTemplateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/GetParamsForCreateTemplate',
      query: {
        'Condition': condition,
        'Manuf': manuf,
        'Model': model,
        'Generation': generation,
        'Trim': trim,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param stockId 
   * @returns FilledTemplateDto Success
   * @throws ApiError
   */
  public static getStockGetFilledTemplate(
stockId?: number,
): CancelablePromise<FilledTemplateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/GetFilledTemplate',
      query: {
        'stockId': stockId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postStockCreateVehicleDescriptionTemplate(
requestBody?: VehicleDescriptionTemplateInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Stock/CreateVehicleDescriptionTemplate',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putStockCreateVehicleDescriptionTemplate(
id: number,
requestBody?: VehicleDescriptionTemplateInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Stock/CreateVehicleDescriptionTemplate/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteStockCreateVehicleDescriptionTemplate(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Stock/CreateVehicleDescriptionTemplate/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns StockCarImage Success
   * @throws ApiError
   */
  public static getStockPhotos(
id: number,
): CancelablePromise<Array<StockCarImage>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/photos/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns string Success
   * @throws ApiError
   */
  public static getStockVideos(
id: number,
): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stock/videos/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Get vehicles in stock
   * @param regNo 
   * @param carNum 
   * @param orderByHighestPrice 
   * @param filterTab
 *
 * 0 = Used
 *
 * 1 = DeliveryMileage
 *
 * 2 = ExDemo
 *
 * 3 = New
 *
 * 4 = External
   * @param filterVehicleType
 *
 * 0 = Undefined
 *
 * 1 = Bike (Motorcycle)
 *
 * 2 = Car
 *
 * 3 = Comp (Component vehicle)
 *
 * 4 = Hgv (Heavy Goods Vehicle)
 *
 * 5 = Van (Light Commercial Vehicle)
   * @param filterBranch 
   * @param filterMake 
   * @param filterModel 
   * @param filterDescription 
   * @param filterTransmission
 *
 * 0 = Any
 *
 * 1 = Manual
 *
 * 2 = Automatic
   * @param filterFuelType
 *
 * 0 = Any
 *
 * 1 = Diesel
 *
 * 2 = Petrol
 *
 * 3 = Electric
 *
 * 4 = Hybrid
   * @param filterBodyStyle
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param filterAgeMin 
   * @param filterAgeMax 
   * @param filterEngineVolumeMin 
   * @param filterEngineVolumeMax 
   * @param filterPriceMin 
   * @param filterPriceMax 
   * @param filterStockType 
   * @param filterLocation 
   * @param filterProgress 
   * @param filterColour 
   * @param filterDoors 
   * @param filterEvent 
   * @param filterIsReserver 
   * @param filterIsOrdered 
   * @param filterIsSpecialOffer 
   * @param filterSpecialOfferTypes 
   * @param filterIsMotability 
   * @param filterFinanceFinanceType
 *
 * 1 = HP
 *
 * 2 = PCP
 *
 * 3 = CS0
 *
 * 5 = x4x4
 *
 * 6 = PCPZero
 *
 * 7 = FL
 *
 * 9 = BCH
   * @param filterFinanceMonthlyPaymentMin 
   * @param filterFinanceMonthlyPaymentMax 
   * @param filterFinanceDeposit 
   * @param filterFinanceTerm 
   * @param filterFinanceMiles 
   * @param filterStockReferenceDaysInStockMin 
   * @param filterStockReferenceDaysInStockMax 
   * @param filterStockReferenceReference 
   * @param filterRetailerAction 
   * @param filterFamily 
   * @param filterRetailerStatus 
   * @param filterRegisterableInMonth 
   * @param filterIsUndefined 
   * @param filterIsSupported 
   * @param filterHasDescription 
   * @param filterHasDescriptionFeed 
   * @param filterAdvertStatus 
   * @param paggingPage 
   * @param paggingPageSize 
   * @returns StockFilteredResponseDTOPagedListData Success
   * @throws ApiError
   */
  public static getVehiclesStock(
regNo?: string,
carNum?: string,
orderByHighestPrice?: boolean,
filterTab?: StockCarsTabFilter,
filterVehicleType?: VehicleTypes,
filterBranch?: number,
filterMake?: string,
filterModel?: Array<string>,
filterDescription?: Array<string>,
filterTransmission?: TransmTypeFilter,
filterFuelType?: FuelTypeFilter,
filterBodyStyle?: CarBodyTypeFilter,
filterAgeMin?: number,
filterAgeMax?: number,
filterEngineVolumeMin?: number,
filterEngineVolumeMax?: number,
filterPriceMin?: number,
filterPriceMax?: number,
filterStockType?: Array<number>,
filterLocation?: Array<number>,
filterProgress?: Array<number>,
filterColour?: Array<string>,
filterDoors?: Array<number>,
filterEvent?: Array<number>,
filterIsReserver?: boolean,
filterIsOrdered?: boolean,
filterIsSpecialOffer?: boolean,
filterSpecialOfferTypes?: Array<number>,
filterIsMotability?: boolean,
filterFinanceFinanceType?: FinanceTypeEnum,
filterFinanceMonthlyPaymentMin?: number,
filterFinanceMonthlyPaymentMax?: number,
filterFinanceDeposit?: number,
filterFinanceTerm?: number,
filterFinanceMiles?: number,
filterStockReferenceDaysInStockMin?: number,
filterStockReferenceDaysInStockMax?: number,
filterStockReferenceReference?: string,
filterRetailerAction?: Array<string>,
filterFamily?: Array<string>,
filterRetailerStatus?: Array<string>,
filterRegisterableInMonth?: boolean,
filterIsUndefined?: boolean,
filterIsSupported?: boolean,
filterHasDescription?: boolean,
filterHasDescriptionFeed?: boolean,
filterAdvertStatus?: Array<AutotraderAdvertStatusEnum>,
paggingPage?: number,
paggingPageSize?: number,
): CancelablePromise<StockFilteredResponseDTOPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/stock',
      query: {
        'RegNo': regNo,
        'CarNum': carNum,
        'OrderByHighestPrice': orderByHighestPrice,
        'Filter.Tab': filterTab,
        'Filter.VehicleType': filterVehicleType,
        'Filter.Branch': filterBranch,
        'Filter.Make': filterMake,
        'Filter.Model': filterModel,
        'Filter.Description': filterDescription,
        'Filter.Transmission': filterTransmission,
        'Filter.FuelType': filterFuelType,
        'Filter.BodyStyle': filterBodyStyle,
        'Filter.Age.Min': filterAgeMin,
        'Filter.Age.Max': filterAgeMax,
        'Filter.EngineVolume.Min': filterEngineVolumeMin,
        'Filter.EngineVolume.Max': filterEngineVolumeMax,
        'Filter.Price.Min': filterPriceMin,
        'Filter.Price.Max': filterPriceMax,
        'Filter.StockType': filterStockType,
        'Filter.Location': filterLocation,
        'Filter.Progress': filterProgress,
        'Filter.Colour': filterColour,
        'Filter.Doors': filterDoors,
        'Filter.Event': filterEvent,
        'Filter.IsReserver': filterIsReserver,
        'Filter.IsOrdered': filterIsOrdered,
        'Filter.IsSpecialOffer': filterIsSpecialOffer,
        'Filter.SpecialOfferTypes': filterSpecialOfferTypes,
        'Filter.IsMotability': filterIsMotability,
        'Filter.Finance.FinanceType': filterFinanceFinanceType,
        'Filter.Finance.MonthlyPayment.Min': filterFinanceMonthlyPaymentMin,
        'Filter.Finance.MonthlyPayment.Max': filterFinanceMonthlyPaymentMax,
        'Filter.Finance.Deposit': filterFinanceDeposit,
        'Filter.Finance.Term': filterFinanceTerm,
        'Filter.Finance.Miles': filterFinanceMiles,
        'Filter.StockReference.DaysInStock.Min': filterStockReferenceDaysInStockMin,
        'Filter.StockReference.DaysInStock.Max': filterStockReferenceDaysInStockMax,
        'Filter.StockReference.Reference': filterStockReferenceReference,
        'Filter.RetailerAction': filterRetailerAction,
        'Filter.Family': filterFamily,
        'Filter.RetailerStatus': filterRetailerStatus,
        'Filter.RegisterableInMonth': filterRegisterableInMonth,
        'Filter.IsUndefined': filterIsUndefined,
        'Filter.IsSupported': filterIsSupported,
        'Filter.HasDescription': filterHasDescription,
        'Filter.HasDescriptionFeed': filterHasDescriptionFeed,
        'Filter.AdvertStatus': filterAdvertStatus,
        'Pagging.Page': paggingPage,
        'Pagging.PageSize': paggingPageSize,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Get vehicles in external stock
   * @param regNo 
   * @param carNum 
   * @param orderByHighestPrice 
   * @param filterTab
 *
 * 0 = Used
 *
 * 1 = DeliveryMileage
 *
 * 2 = ExDemo
 *
 * 3 = New
 *
 * 4 = External
   * @param filterVehicleType
 *
 * 0 = Undefined
 *
 * 1 = Bike (Motorcycle)
 *
 * 2 = Car
 *
 * 3 = Comp (Component vehicle)
 *
 * 4 = Hgv (Heavy Goods Vehicle)
 *
 * 5 = Van (Light Commercial Vehicle)
   * @param filterBranch 
   * @param filterMake 
   * @param filterModel 
   * @param filterDescription 
   * @param filterTransmission
 *
 * 0 = Any
 *
 * 1 = Manual
 *
 * 2 = Automatic
   * @param filterFuelType
 *
 * 0 = Any
 *
 * 1 = Diesel
 *
 * 2 = Petrol
 *
 * 3 = Electric
 *
 * 4 = Hybrid
   * @param filterBodyStyle
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param filterAgeMin 
   * @param filterAgeMax 
   * @param filterEngineVolumeMin 
   * @param filterEngineVolumeMax 
   * @param filterPriceMin 
   * @param filterPriceMax 
   * @param filterStockType 
   * @param filterLocation 
   * @param filterProgress 
   * @param filterColour 
   * @param filterDoors 
   * @param filterEvent 
   * @param filterIsReserver 
   * @param filterIsOrdered 
   * @param filterIsSpecialOffer 
   * @param filterSpecialOfferTypes 
   * @param filterIsMotability 
   * @param filterFinanceFinanceType
 *
 * 1 = HP
 *
 * 2 = PCP
 *
 * 3 = CS0
 *
 * 5 = x4x4
 *
 * 6 = PCPZero
 *
 * 7 = FL
 *
 * 9 = BCH
   * @param filterFinanceMonthlyPaymentMin 
   * @param filterFinanceMonthlyPaymentMax 
   * @param filterFinanceDeposit 
   * @param filterFinanceTerm 
   * @param filterFinanceMiles 
   * @param filterStockReferenceDaysInStockMin 
   * @param filterStockReferenceDaysInStockMax 
   * @param filterStockReferenceReference 
   * @param filterRetailerAction 
   * @param filterFamily 
   * @param filterRetailerStatus 
   * @param filterRegisterableInMonth 
   * @param filterIsUndefined 
   * @param filterIsSupported 
   * @param filterHasDescription 
   * @param filterHasDescriptionFeed 
   * @param filterAdvertStatus 
   * @param paggingPage 
   * @param paggingPageSize 
   * @returns ExternalStockFilteredResponseDTOPagedListData Success
   * @throws ApiError
   */
  public static getVehiclesExternalStock(
regNo?: string,
carNum?: string,
orderByHighestPrice?: boolean,
filterTab?: StockCarsTabFilter,
filterVehicleType?: VehicleTypes,
filterBranch?: number,
filterMake?: string,
filterModel?: Array<string>,
filterDescription?: Array<string>,
filterTransmission?: TransmTypeFilter,
filterFuelType?: FuelTypeFilter,
filterBodyStyle?: CarBodyTypeFilter,
filterAgeMin?: number,
filterAgeMax?: number,
filterEngineVolumeMin?: number,
filterEngineVolumeMax?: number,
filterPriceMin?: number,
filterPriceMax?: number,
filterStockType?: Array<number>,
filterLocation?: Array<number>,
filterProgress?: Array<number>,
filterColour?: Array<string>,
filterDoors?: Array<number>,
filterEvent?: Array<number>,
filterIsReserver?: boolean,
filterIsOrdered?: boolean,
filterIsSpecialOffer?: boolean,
filterSpecialOfferTypes?: Array<number>,
filterIsMotability?: boolean,
filterFinanceFinanceType?: FinanceTypeEnum,
filterFinanceMonthlyPaymentMin?: number,
filterFinanceMonthlyPaymentMax?: number,
filterFinanceDeposit?: number,
filterFinanceTerm?: number,
filterFinanceMiles?: number,
filterStockReferenceDaysInStockMin?: number,
filterStockReferenceDaysInStockMax?: number,
filterStockReferenceReference?: string,
filterRetailerAction?: Array<string>,
filterFamily?: Array<string>,
filterRetailerStatus?: Array<string>,
filterRegisterableInMonth?: boolean,
filterIsUndefined?: boolean,
filterIsSupported?: boolean,
filterHasDescription?: boolean,
filterHasDescriptionFeed?: boolean,
filterAdvertStatus?: Array<AutotraderAdvertStatusEnum>,
paggingPage?: number,
paggingPageSize?: number,
): CancelablePromise<ExternalStockFilteredResponseDTOPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/external-stock',
      query: {
        'RegNo': regNo,
        'CarNum': carNum,
        'OrderByHighestPrice': orderByHighestPrice,
        'Filter.Tab': filterTab,
        'Filter.VehicleType': filterVehicleType,
        'Filter.Branch': filterBranch,
        'Filter.Make': filterMake,
        'Filter.Model': filterModel,
        'Filter.Description': filterDescription,
        'Filter.Transmission': filterTransmission,
        'Filter.FuelType': filterFuelType,
        'Filter.BodyStyle': filterBodyStyle,
        'Filter.Age.Min': filterAgeMin,
        'Filter.Age.Max': filterAgeMax,
        'Filter.EngineVolume.Min': filterEngineVolumeMin,
        'Filter.EngineVolume.Max': filterEngineVolumeMax,
        'Filter.Price.Min': filterPriceMin,
        'Filter.Price.Max': filterPriceMax,
        'Filter.StockType': filterStockType,
        'Filter.Location': filterLocation,
        'Filter.Progress': filterProgress,
        'Filter.Colour': filterColour,
        'Filter.Doors': filterDoors,
        'Filter.Event': filterEvent,
        'Filter.IsReserver': filterIsReserver,
        'Filter.IsOrdered': filterIsOrdered,
        'Filter.IsSpecialOffer': filterIsSpecialOffer,
        'Filter.SpecialOfferTypes': filterSpecialOfferTypes,
        'Filter.IsMotability': filterIsMotability,
        'Filter.Finance.FinanceType': filterFinanceFinanceType,
        'Filter.Finance.MonthlyPayment.Min': filterFinanceMonthlyPaymentMin,
        'Filter.Finance.MonthlyPayment.Max': filterFinanceMonthlyPaymentMax,
        'Filter.Finance.Deposit': filterFinanceDeposit,
        'Filter.Finance.Term': filterFinanceTerm,
        'Filter.Finance.Miles': filterFinanceMiles,
        'Filter.StockReference.DaysInStock.Min': filterStockReferenceDaysInStockMin,
        'Filter.StockReference.DaysInStock.Max': filterStockReferenceDaysInStockMax,
        'Filter.StockReference.Reference': filterStockReferenceReference,
        'Filter.RetailerAction': filterRetailerAction,
        'Filter.Family': filterFamily,
        'Filter.RetailerStatus': filterRetailerStatus,
        'Filter.RegisterableInMonth': filterRegisterableInMonth,
        'Filter.IsUndefined': filterIsUndefined,
        'Filter.IsSupported': filterIsSupported,
        'Filter.HasDescription': filterHasDescription,
        'Filter.HasDescriptionFeed': filterHasDescriptionFeed,
        'Filter.AdvertStatus': filterAdvertStatus,
        'Pagging.Page': paggingPage,
        'Pagging.PageSize': paggingPageSize,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Run price updates for vehicles in external stock
   * @returns boolean Success
   * @throws ApiError
   */
  public static putVehiclesExternalStock(): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicles/external-stock',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Export vehicles in external stock
   * @param regNo 
   * @param carNum 
   * @param orderByHighestPrice 
   * @param filterTab
 *
 * 0 = Used
 *
 * 1 = DeliveryMileage
 *
 * 2 = ExDemo
 *
 * 3 = New
 *
 * 4 = External
   * @param filterVehicleType
 *
 * 0 = Undefined
 *
 * 1 = Bike (Motorcycle)
 *
 * 2 = Car
 *
 * 3 = Comp (Component vehicle)
 *
 * 4 = Hgv (Heavy Goods Vehicle)
 *
 * 5 = Van (Light Commercial Vehicle)
   * @param filterBranch 
   * @param filterMake 
   * @param filterModel 
   * @param filterDescription 
   * @param filterTransmission
 *
 * 0 = Any
 *
 * 1 = Manual
 *
 * 2 = Automatic
   * @param filterFuelType
 *
 * 0 = Any
 *
 * 1 = Diesel
 *
 * 2 = Petrol
 *
 * 3 = Electric
 *
 * 4 = Hybrid
   * @param filterBodyStyle
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param filterAgeMin 
   * @param filterAgeMax 
   * @param filterEngineVolumeMin 
   * @param filterEngineVolumeMax 
   * @param filterPriceMin 
   * @param filterPriceMax 
   * @param filterStockType 
   * @param filterLocation 
   * @param filterProgress 
   * @param filterColour 
   * @param filterDoors 
   * @param filterEvent 
   * @param filterIsReserver 
   * @param filterIsOrdered 
   * @param filterIsSpecialOffer 
   * @param filterSpecialOfferTypes 
   * @param filterIsMotability 
   * @param filterFinanceFinanceType
 *
 * 1 = HP
 *
 * 2 = PCP
 *
 * 3 = CS0
 *
 * 5 = x4x4
 *
 * 6 = PCPZero
 *
 * 7 = FL
 *
 * 9 = BCH
   * @param filterFinanceMonthlyPaymentMin 
   * @param filterFinanceMonthlyPaymentMax 
   * @param filterFinanceDeposit 
   * @param filterFinanceTerm 
   * @param filterFinanceMiles 
   * @param filterStockReferenceDaysInStockMin 
   * @param filterStockReferenceDaysInStockMax 
   * @param filterStockReferenceReference 
   * @param filterRetailerAction 
   * @param filterFamily 
   * @param filterRetailerStatus 
   * @param filterRegisterableInMonth 
   * @param filterIsUndefined 
   * @param filterIsSupported 
   * @param filterHasDescription 
   * @param filterHasDescriptionFeed 
   * @param filterAdvertStatus 
   * @param paggingPage 
   * @param paggingPageSize 
   * @returns any Success
   * @throws ApiError
   */
  public static getVehiclesExportExternalStock(
    regNo?: string,
    carNum?: string,
    orderByHighestPrice?: boolean,
    filterTab?: StockCarsTabFilter,
    filterVehicleType?: VehicleTypes,
    filterBranch?: number,
    filterMake?: string,
    filterModel?: Array<string>,
    filterDescription?: Array<string>,
    filterTransmission?: TransmTypeFilter,
    filterFuelType?: FuelTypeFilter,
    filterBodyStyle?: CarBodyTypeFilter,
    filterAgeMin?: number,
    filterAgeMax?: number,
    filterEngineVolumeMin?: number,
    filterEngineVolumeMax?: number,
    filterPriceMin?: number,
    filterPriceMax?: number,
    filterStockType?: Array<number>,
    filterLocation?: Array<number>,
    filterProgress?: Array<number>,
    filterColour?: Array<string>,
    filterDoors?: Array<number>,
    filterEvent?: Array<number>,
    filterIsReserver?: boolean,
    filterIsOrdered?: boolean,
    filterIsSpecialOffer?: boolean,
    filterSpecialOfferTypes?: Array<number>,
    filterIsMotability?: boolean,
    filterFinanceFinanceType?: FinanceTypeEnum,
    filterFinanceMonthlyPaymentMin?: number,
    filterFinanceMonthlyPaymentMax?: number,
    filterFinanceDeposit?: number,
    filterFinanceTerm?: number,
    filterFinanceMiles?: number,
    filterStockReferenceDaysInStockMin?: number,
    filterStockReferenceDaysInStockMax?: number,
    filterStockReferenceReference?: string,
    filterRetailerAction?: Array<string>,
    filterFamily?: Array<string>,
    filterRetailerStatus?: Array<string>,
    filterRegisterableInMonth?: boolean,
    filterIsUndefined?: boolean,
    filterIsSupported?: boolean,
    paggingPage?: number,
    paggingPageSize?: number,
filterHasDescription?: boolean,
filterHasDescriptionFeed?: boolean,
filterAdvertStatus?: Array<AutotraderAdvertStatusEnum>,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/export-external-stock',
      query: {
        'RegNo': regNo,
        'CarNum': carNum,
        'OrderByHighestPrice': orderByHighestPrice,
        'Filter.Tab': filterTab,
        'Filter.VehicleType': filterVehicleType,
        'Filter.Branch': filterBranch,
        'Filter.Make': filterMake,
        'Filter.Model': filterModel,
        'Filter.Description': filterDescription,
        'Filter.Transmission': filterTransmission,
        'Filter.FuelType': filterFuelType,
        'Filter.BodyStyle': filterBodyStyle,
        'Filter.Age.Min': filterAgeMin,
        'Filter.Age.Max': filterAgeMax,
        'Filter.EngineVolume.Min': filterEngineVolumeMin,
        'Filter.EngineVolume.Max': filterEngineVolumeMax,
        'Filter.Price.Min': filterPriceMin,
        'Filter.Price.Max': filterPriceMax,
        'Filter.StockType': filterStockType,
        'Filter.Location': filterLocation,
        'Filter.Progress': filterProgress,
        'Filter.Colour': filterColour,
        'Filter.Doors': filterDoors,
        'Filter.Event': filterEvent,
        'Filter.IsReserver': filterIsReserver,
        'Filter.IsOrdered': filterIsOrdered,
        'Filter.IsSpecialOffer': filterIsSpecialOffer,
        'Filter.SpecialOfferTypes': filterSpecialOfferTypes,
        'Filter.IsMotability': filterIsMotability,
        'Filter.Finance.FinanceType': filterFinanceFinanceType,
        'Filter.Finance.MonthlyPayment.Min': filterFinanceMonthlyPaymentMin,
        'Filter.Finance.MonthlyPayment.Max': filterFinanceMonthlyPaymentMax,
        'Filter.Finance.Deposit': filterFinanceDeposit,
        'Filter.Finance.Term': filterFinanceTerm,
        'Filter.Finance.Miles': filterFinanceMiles,
        'Filter.StockReference.DaysInStock.Min': filterStockReferenceDaysInStockMin,
        'Filter.StockReference.DaysInStock.Max': filterStockReferenceDaysInStockMax,
        'Filter.StockReference.Reference': filterStockReferenceReference,
        'Filter.RetailerAction': filterRetailerAction,
        'Filter.Family': filterFamily,
        'Filter.RetailerStatus': filterRetailerStatus,
        'Filter.RegisterableInMonth': filterRegisterableInMonth,
        'Filter.IsUndefined': filterIsUndefined,
        'Filter.IsSupported': filterIsSupported,
        'Filter.HasDescription': filterHasDescription,
        'Filter.HasDescriptionFeed': filterHasDescriptionFeed,
        'Filter.AdvertStatus': filterAdvertStatus,
        'Pagging.Page': paggingPage,
        'Pagging.PageSize': paggingPageSize,
      },
    });
  }

  /**
   * Get concrete vehicle in external stock
   * @param id 
   * @returns ExternalStockFilteredResponseDTO Success
   * @throws ApiError
   */
  public static getVehiclesExternalStock1(
id: number,
): CancelablePromise<ExternalStockFilteredResponseDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/external-stock/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Get available filters for external stock vehicles
   * @param tab
 *
 * 0 = Used
 *
 * 1 = DeliveryMileage
 *
 * 2 = ExDemo
 *
 * 3 = New
 *
 * 4 = External
   * @param vehicleType
 *
 * 0 = Undefined
 *
 * 1 = Bike (Motorcycle)
 *
 * 2 = Car
 *
 * 3 = Comp (Component vehicle)
 *
 * 4 = Hgv (Heavy Goods Vehicle)
 *
 * 5 = Van (Light Commercial Vehicle)
   * @param branch 
   * @param make 
   * @param model 
   * @param description 
   * @param transmission
 *
 * 0 = Any
 *
 * 1 = Manual
 *
 * 2 = Automatic
   * @param fuelType
 *
 * 0 = Any
 *
 * 1 = Diesel
 *
 * 2 = Petrol
 *
 * 3 = Electric
 *
 * 4 = Hybrid
   * @param bodyStyle
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param ageMin 
   * @param ageMax 
   * @param engineVolumeMin 
   * @param engineVolumeMax 
   * @param priceMin 
   * @param priceMax 
   * @param stockType 
   * @param location 
   * @param progress 
   * @param colour 
   * @param doors 
   * @param event 
   * @param isReserver 
   * @param isOrdered 
   * @param isSpecialOffer 
   * @param specialOfferTypes 
   * @param isMotability 
   * @param financeFinanceType
 *
 * 1 = HP
 *
 * 2 = PCP
 *
 * 3 = CS0
 *
 * 5 = x4x4
 *
 * 6 = PCPZero
 *
 * 7 = FL
 *
 * 9 = BCH
   * @param financeMonthlyPaymentMin 
   * @param financeMonthlyPaymentMax 
   * @param financeDeposit 
   * @param financeTerm 
   * @param financeMiles 
   * @param stockReferenceDaysInStockMin 
   * @param stockReferenceDaysInStockMax 
   * @param stockReferenceReference 
   * @param retailerAction 
   * @param family 
   * @param retailerStatus 
   * @param registerableInMonth 
   * @param isUndefined 
   * @param isSupported 
   * @param hasDescription 
   * @param hasDescriptionFeed 
   * @param advertStatus 
   * @returns StockFilterResponseDTO Success
   * @throws ApiError
   */
  public static getVehiclesStockExternalFilters(
tab?: StockCarsTabFilter,
vehicleType?: VehicleTypes,
branch?: number,
make?: string,
model?: Array<string>,
description?: Array<string>,
transmission?: TransmTypeFilter,
fuelType?: FuelTypeFilter,
bodyStyle?: CarBodyTypeFilter,
ageMin?: number,
ageMax?: number,
engineVolumeMin?: number,
engineVolumeMax?: number,
priceMin?: number,
priceMax?: number,
stockType?: Array<number>,
location?: Array<number>,
progress?: Array<number>,
colour?: Array<string>,
doors?: Array<number>,
event?: Array<number>,
isReserver?: boolean,
isOrdered?: boolean,
isSpecialOffer?: boolean,
specialOfferTypes?: Array<number>,
isMotability?: boolean,
financeFinanceType?: FinanceTypeEnum,
financeMonthlyPaymentMin?: number,
financeMonthlyPaymentMax?: number,
financeDeposit?: number,
financeTerm?: number,
financeMiles?: number,
stockReferenceDaysInStockMin?: number,
stockReferenceDaysInStockMax?: number,
stockReferenceReference?: string,
retailerAction?: Array<string>,
family?: Array<string>,
retailerStatus?: Array<string>,
registerableInMonth?: boolean,
isUndefined?: boolean,
isSupported?: boolean,
hasDescription?: boolean,
hasDescriptionFeed?: boolean,
advertStatus?: Array<AutotraderAdvertStatusEnum>,
): CancelablePromise<StockFilterResponseDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/stock/external-filters',
      query: {
        'Tab': tab,
        'VehicleType': vehicleType,
        'Branch': branch,
        'Make': make,
        'Model': model,
        'Description': description,
        'Transmission': transmission,
        'FuelType': fuelType,
        'BodyStyle': bodyStyle,
        'Age.Min': ageMin,
        'Age.Max': ageMax,
        'EngineVolume.Min': engineVolumeMin,
        'EngineVolume.Max': engineVolumeMax,
        'Price.Min': priceMin,
        'Price.Max': priceMax,
        'StockType': stockType,
        'Location': location,
        'Progress': progress,
        'Colour': colour,
        'Doors': doors,
        'Event': event,
        'IsReserver': isReserver,
        'IsOrdered': isOrdered,
        'IsSpecialOffer': isSpecialOffer,
        'SpecialOfferTypes': specialOfferTypes,
        'IsMotability': isMotability,
        'Finance.FinanceType': financeFinanceType,
        'Finance.MonthlyPayment.Min': financeMonthlyPaymentMin,
        'Finance.MonthlyPayment.Max': financeMonthlyPaymentMax,
        'Finance.Deposit': financeDeposit,
        'Finance.Term': financeTerm,
        'Finance.Miles': financeMiles,
        'StockReference.DaysInStock.Min': stockReferenceDaysInStockMin,
        'StockReference.DaysInStock.Max': stockReferenceDaysInStockMax,
        'StockReference.Reference': stockReferenceReference,
        'RetailerAction': retailerAction,
        'Family': family,
        'RetailerStatus': retailerStatus,
        'RegisterableInMonth': registerableInMonth,
        'IsUndefined': isUndefined,
        'IsSupported': isSupported,
        'HasDescription': hasDescription,
        'HasDescriptionFeed': hasDescriptionFeed,
        'AdvertStatus': advertStatus,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Get available filters for stock vehicles
   * @param tab
 *
 * 0 = Used
 *
 * 1 = DeliveryMileage
 *
 * 2 = ExDemo
 *
 * 3 = New
 *
 * 4 = External
   * @param vehicleType
 *
 * 0 = Undefined
 *
 * 1 = Bike (Motorcycle)
 *
 * 2 = Car
 *
 * 3 = Comp (Component vehicle)
 *
 * 4 = Hgv (Heavy Goods Vehicle)
 *
 * 5 = Van (Light Commercial Vehicle)
   * @param branch 
   * @param make 
   * @param model 
   * @param description 
   * @param transmission
 *
 * 0 = Any
 *
 * 1 = Manual
 *
 * 2 = Automatic
   * @param fuelType
 *
 * 0 = Any
 *
 * 1 = Diesel
 *
 * 2 = Petrol
 *
 * 3 = Electric
 *
 * 4 = Hybrid
   * @param bodyStyle
 *
 * 0 = All
 *
 * 1 = Coupe
 *
 * 2 = Estate
 *
 * 3 = Hatchback
 *
 * 4 = MPV
 *
 * 5 = SUV
 *
 * 6 = Unleasted
   * @param ageMin 
   * @param ageMax 
   * @param engineVolumeMin 
   * @param engineVolumeMax 
   * @param priceMin 
   * @param priceMax 
   * @param stockType 
   * @param location 
   * @param progress 
   * @param colour 
   * @param doors 
   * @param event 
   * @param isReserver 
   * @param isOrdered 
   * @param isSpecialOffer 
   * @param specialOfferTypes 
   * @param isMotability 
   * @param financeFinanceType
 *
 * 1 = HP
 *
 * 2 = PCP
 *
 * 3 = CS0
 *
 * 5 = x4x4
 *
 * 6 = PCPZero
 *
 * 7 = FL
 *
 * 9 = BCH
   * @param financeMonthlyPaymentMin 
   * @param financeMonthlyPaymentMax 
   * @param financeDeposit 
   * @param financeTerm 
   * @param financeMiles 
   * @param stockReferenceDaysInStockMin 
   * @param stockReferenceDaysInStockMax 
   * @param stockReferenceReference 
   * @param retailerAction 
   * @param family 
   * @param retailerStatus 
   * @param registerableInMonth 
   * @param isUndefined 
   * @param isSupported 
   * @returns boolean Success
   * @param withoutEmptyPrice 
   * @param hasDescription 
   * @param hasDescriptionFeed 
   * @throws ApiError
   */
  public static getVehiclesStockFilters(
tab?: StockCarsTabFilter,
vehicleType?: VehicleTypes,
branch?: number,
make?: string,
model?: Array<string>,
description?: Array<string>,
transmission?: TransmTypeFilter,
fuelType?: FuelTypeFilter,
bodyStyle?: CarBodyTypeFilter,
ageMin?: number,
ageMax?: number,
engineVolumeMin?: number,
engineVolumeMax?: number,
priceMin?: number,
priceMax?: number,
stockType?: Array<number>,
location?: Array<number>,
progress?: Array<number>,
colour?: Array<string>,
doors?: Array<number>,
event?: Array<number>,
isReserver?: boolean,
isOrdered?: boolean,
isSpecialOffer?: boolean,
specialOfferTypes?: Array<number>,
isMotability?: boolean,
financeFinanceType?: FinanceTypeEnum,
financeMonthlyPaymentMin?: number,
financeMonthlyPaymentMax?: number,
financeDeposit?: number,
financeTerm?: number,
financeMiles?: number,
hasDescription?: boolean,
hasDescriptionFeed?: boolean,
stockReferenceDaysInStockMin?: number,
stockReferenceDaysInStockMax?: number,
stockReferenceReference?: string,
retailerAction?: Array<string>,
family?: Array<string>,
retailerStatus?: Array<string>,
registerableInMonth?: boolean,
isUndefined?: boolean,
isSupported?: boolean,
advertStatus?: Array<AutotraderAdvertStatusEnum>,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/stock/filters',
      query: {
        'Tab': tab,
        'VehicleType': vehicleType,
        'Branch': branch,
        'Make': make,
        'Model': model,
        'Description': description,
        'Transmission': transmission,
        'FuelType': fuelType,
        'BodyStyle': bodyStyle,
        'Age.Min': ageMin,
        'Age.Max': ageMax,
        'EngineVolume.Min': engineVolumeMin,
        'EngineVolume.Max': engineVolumeMax,
        'Price.Min': priceMin,
        'Price.Max': priceMax,
        'StockType': stockType,
        'Location': location,
        'Progress': progress,
        'Colour': colour,
        'Doors': doors,
        'Event': event,
        'IsReserver': isReserver,
        'IsOrdered': isOrdered,
        'IsSpecialOffer': isSpecialOffer,
        'SpecialOfferTypes': specialOfferTypes,
        'IsMotability': isMotability,
        'Finance.FinanceType': financeFinanceType,
        'Finance.MonthlyPayment.Min': financeMonthlyPaymentMin,
        'Finance.MonthlyPayment.Max': financeMonthlyPaymentMax,
        'Finance.Deposit': financeDeposit,
        'Finance.Term': financeTerm,
        'Finance.Miles': financeMiles,
        'StockReference.DaysInStock.Min': stockReferenceDaysInStockMin,
        'StockReference.DaysInStock.Max': stockReferenceDaysInStockMax,
        'StockReference.Reference': stockReferenceReference,
        'RetailerAction': retailerAction,
        'Family': family,
        'RetailerStatus': retailerStatus,
        'RegisterableInMonth': registerableInMonth,
        'IsUndefined': isUndefined,
        'IsSupported': isSupported,
        'HasDescription': hasDescription,
        'HasDescriptionFeed': hasDescriptionFeed,
        'AdvertStatus': advertStatus,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * Check stock is availability
   * @param stockValue Stock Number or Stock Id or Reg Number
   * @returns AvailableStockInfo Success
   * @throws ApiError
   */
  public static getVehiclesStockCheckAvailability(
stockValue: string,
): CancelablePromise<AvailableStockInfo> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/stock/check-availability/{stockValue}',
      path: {
        'stockValue': stockValue,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Update rfv values for all used stock vehicles
   * @returns void 
   * @throws ApiError
   */
  public static getVehiclesStockUsedUpdateRfv(): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/stock/used/update-rfv',
    });
  }

  /**
   * @param stockId 
   * @returns any Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderUsedLookup(
stockId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/used/lookup/{stockId}',
      path: {
        'stockId': stockId,
      },
    });
  }

  /**
   * @param stockId 
   * @param modelId 
   * @param generationId 
   * @param trim 
   * @param derivativeId 
   * @returns any Success
   * @throws ApiError
   */
  public static getVehiclesAutotraderNewLookup(
stockId: number,
modelId?: string,
generationId?: string,
trim?: string,
derivativeId?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicles/autotrader/new/lookup/{stockId}',
      path: {
        'stockId': stockId,
      },
      query: {
        'modelId': modelId,
        'generationId': generationId,
        'trim': trim,
        'derivativeId': derivativeId,
      },
    });
  }

}
